/** Stable unique id for in-modal payment rows (sales, exchange). */
export function createPaymentEntryId(): string {
  return `payment-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
